module.exports = __webpack_public_path__ + "media/site/images/icons/web-design-icon-d934a078a77dd8cf3e01352857d5f6b8.svg";